export const isNonNullable = <T>(val: T): val is NonNullable<T> =>
  val !== undefined && val !== null;

export const isString = (val: unknown): val is string => typeof val === 'string';

// A string carrying a real value: rejects '' and the literal 'undefined' (a JS
// `undefined` stringified into a URL query or template). Keeps that poison
// value out of stored ids and redirect params.
export const isMeaningfulString = (val: unknown): val is string =>
  typeof val === 'string' && val !== '' && val !== 'undefined';

export const isNumber = (val: unknown): val is number => typeof val === 'number';

export const isBoolean = (val: unknown): val is boolean => typeof val === 'boolean';

// Non-null object (rejects `null`, accepts plain objects + arrays).
export const isObject = (val: unknown): val is object => val !== null && typeof val === 'object';
